// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__OAKJ+","btn":"NotFound_btn__ZdBEt"};